import axios from "axios";

export const state = {
    savingpackages: [],
};

export const getters = {
    savingpackages: state => state.savingpackages,
};

export const mutations = {
    setMethods(savingpackages, newValue) {
        state.savingpackages = newValue
    },
};

export const actions = {
    async fetchSavingPackages({ commit }) {
        await axios.get('/savingpackages').then(res => {
            commit('setMethods', res.data.packages)
        })
    },
};
